import { addStyles } from 'ethcss'
import { IStyles, colors, mediaCSS } from 'theme'

export const scheduleDevicesModalStyles: IStyles = {
    modalWrapper: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'stretch',
        justifyContent: 'flex-end',
        padding: '36px 18px 36px 24px',
        backgroundColor: 'rgba(20, 24, 32, 0.48)',
        [mediaCSS.mob]: {
            padding: 12,
        },
    },
    modalInner: {
        display: 'flex',
        width: 384,
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'calc(100vh - 72px)',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: colors.white,
        borderRadius: 12,
        boxShadow: '0 24px 64px rgba(20, 32, 56, 0.24)',
        [mediaCSS.mob]: {
            width: '100%',
            maxHeight: 'calc(100vh - 24px)',
        },
    },
    modalHeader: {
        display: 'flex',
        minHeight: 64,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        borderBottom: `1px solid ${colors.greyLight}`,
    },
    closeButton: {
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        border: 0,
        borderRadius: 6,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F3F5F8',
        },
    },
    modalBody: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
        padding: '16px 24px 8px',
    },
    searchField: {
        marginBottom: 12,
    },
    deviceList: {
        flex: 1,
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        border: '1px solid rgba(0,0,0,0.08)',
        borderRadius: 12,
        padding: '4px 0',
    },
    deviceRow: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        padding: '10px 12px',
        transition: 'background-color 0.15s ease',
        '&:hover': {
            backgroundColor: colors.greyLight,
        },
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    deviceRowCheckbox: {
        flexShrink: 0,
        marginRight: 12,
    },
    emptyList: {
        padding: '24px 12px',
        textAlign: 'center',
        opacity: 0.7,
    },
    footer: {
        padding: '16px 24px',
        borderTop: `1px solid ${colors.greyLight}`,
        boxShadow: '0 -8px 24px rgba(28, 39, 60, 0.04)',
    },
    actionButton: {
        width: '100%',
        minHeight: 56,
        borderRadius: '6px !important',
        backgroundColor: '#286CF2 !important',
        borderColor: '#286CF2 !important',
        '&:hover': {
            backgroundColor: '#1F5FE0 !important',
        },
    },
}

addStyles(scheduleDevicesModalStyles)
